import FetchJsonClient from "fetch-json-client";

class WebService extends FetchJsonClient {
    constructor(base_url, token) {
        super();
        this.configure(config => {
            config.withHeader("Accept", "application/json");
            if (token) {
                config.withBaseUrl(base_url);
                config.withHeader("Authorization", `Bearer ${token}`);
            } else {
                config.withBaseUrl(base_url);
            }
        });
    }
}

export default new (class {
    get shopify() {
        const base_url = process.env.REACT_APP_WS_SHOPIFY;
        return new WebService(base_url);
    }
})();



// WEBPACK FOOTER //
// ./src/_constants/webservices.js